import React, { useContext, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  Button,
  CircularProgress,
  DialogActions,
  Grid,
  TextField,
  Typography,
} from "@mui/material";

import { CreatePCAContext } from "./helpers";

import { pcaFindCm, pcaFetchAllActiveSkills } from "../../Actions";

const DisplayCMDetails = ({ cmDetails }) => {
  const contextObject = useContext(CreatePCAContext);

  const markup = [
    {
      label: "Name of Corps Member",
      value: cmDetails.cmName,
    },
    {
      label: "Place of Primary Assignment",
      value: cmDetails.ppa,
    },
    {
      label: "Gender",
      value: contextObject.genderSchema[`${cmDetails.gender}`],
    },
  ];

  const parentGridProps = {
    gap: 3,
    container: true,
    item: true,
    xs: true,
    sx: {
      display: "flex",
      flexDirection: "column",
      mt: "3rem",
    },
  };
  return (
    <Grid {...parentGridProps}>
      <Typography>Corps Member Details</Typography>

      {markup.map((field) => (
        <TextField
          key={field.label}
          fullWidth
          size="small"
          value={field.value}
          variant="outlined"
          label={field.label}
          InputProps={{
            readOnly: true,
          }}
        />
      ))}
    </Grid>
  );
};

const StepOne = () => {
  const contextObject = useContext(CreatePCAContext);
  const globalDispatch = useDispatch();

  const pcaReducer = (state) => state.postCampActivityReducer;
  const usersReducer = (state) => state.usersReducer;

  const { cmDetails, fetchingCM, fetchCMSuccess } = useSelector(pcaReducer);
  const { authUser } = useSelector(usersReducer);

  const [stateCode, setStateCode] = useState("");

  useEffect(() => {
    globalDispatch(pcaFetchAllActiveSkills());
  }, []);

  function handleStateCodeOnChange(event) {
    setStateCode(event.target.value);
  }

  function handleFindCM() {
    globalDispatch(
      pcaFindCm({
        stateCode: stateCode,
        stateId: authUser.stateID,
        userId: authUser.id,
        hash: "",
      })
    );
  }

  const findCmTextFieldProps = {
    autoFocus: true,
    fullWidth: true,
    size: "small",
    value: stateCode,
    variant: "outlined",
    placeholder: "Type here",
    label: "Enter Corps Member State Code",
    onChange: handleStateCodeOnChange,
    error: !fetchingCM && fetchCMSuccess && Object.keys(cmDetails).length < 1,
    helperText:
      !fetchingCM &&
      fetchCMSuccess &&
      Object.keys(cmDetails).length < 1 &&
      "Corps Member not found. Please check the state code and try again.",
  };

  return (
    <>
      <Grid
        gap={3}
        container
        item
        xs
        sx={{ display: "flex", flexDirection: "column", pt: 3 }}
      >
        <TextField {...findCmTextFieldProps} />
        <Button
          variant="contained"
          onClick={handleFindCM}
          disabled={stateCode.length < 1 || fetchingCM === true}
        >
          {fetchingCM === true ? (
            <CircularProgress size={24} sx={{ color: "white" }} />
          ) : (
            <>Find Corps Member</>
          )}
        </Button>
      </Grid>

      {!fetchingCM && (
        <>
          {Object.keys(cmDetails).length > 0 && (
            <DisplayCMDetails
              fetchComplete={fetchCMSuccess}
              cmDetails={cmDetails}
            />
          )}
        </>
      )}

      <DialogActions sx={{ mt: "1rem" }}>
        <Button
          variant="contained"
          color="primary"
          disabled={Object.keys(cmDetails).length < 1 || fetchingCM}
          onClick={contextObject.handleNextStep}
        >
          Next
        </Button>
      </DialogActions>
    </>
  );
};

export default StepOne;
